export default __webpack_public_path__ + "static/media/terms.0d562388.svg";